<template>
  <div>
  <div class="shareGetCouponPage">
    <XR-head titleText="抢券" :rightShow="true" ref="" class="title" >
      
    </XR-head>
      <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" :enableRefresh="false" ref="scroll">
      <div class="coupon_banner_bg">
        <img src=" ../static/XRGsharecoupon1.png" alt="" width="100%">
        <div class="couponlist">
          <div v-if="shareCouponList.length==0" :style="{ height:commonCouponHeight+'px'}"  style="width:100%;">
            <div style="width:100%;text-align:center;float:left;height:75%;">
              <div style="width:18%;float:left;height:1px;"></div>
              <div style="width:64%;float:left;height:100%;padding:20px 20px 0px 20px;">
              <img src="/static/noplatformcouponimg.png"  height="80%" width="65%" style="margin-left:17%;" />
              <p style="font-size:16px;text-align:center;color:white;">暂无优惠券,敬请期待~</p>
              </div>
              <div style="width:18%;float:left;height:1px;"></div>
            </div>
          </div>
          <div v-if="shareCouponList.length>0" class="couponcontainer" :style="{width:couponcenterWidth + 'px', height:commonCouponHeight+'px'}">
            <div class="couponitem" :style="{width: commonCouponWidth+'px', height:commonCouponHeight+'px'}" v-for="(couponRow,index) in shareCouponList" :key="couponRow">
              <div class="couponItemContent" :style="{height:couponItemContentHeight+'px'}">                
                <div class="couponitemPrice">{{couponRow.Money}}</div>
                <div class="couponitemRemark">
                    <div class="txtprice">满{{couponRow.FullMoney}}元可用</div>
                    <div class="txttype">{{couponRow.TypeName}}</div>
                    <div class="txtremark">{{couponRow.Name}}</div>
                </div>
                <div class="couponimg_conpon_bg_time txttime">
                  <!-- 使用时间<br /> -->{{couponRow.StartTime}}~{{couponRow.EndTime}}
                </div>
              </div>
			        <div class="couponItemBtn" v-if="couponRow.ReceiveStatus==0" @click="btnClick(couponRow.Id,index)" :style="{height:couponItemBtnHeight+'px', lineHeight: couponItemBtnHeight +'px'}">立即领取</div>
              <div class="couponItemBtn" v-if="couponRow.ReceiveStatus==1" @click="goToCouponUsing(couponRow.Id)" :style="{height:couponItemBtnHeight+'px', lineHeight: couponItemBtnHeight +'px'}">去使用</div>
            </div>
              <div class="couponitem" :style="{width: commonCouponWidth+'px', height:commonCouponHeight+'px'}" v-if="shareCouponList.length<=2">
              <img src="/static/XRGcouponCenter.png" width="100%" height="100%" v-if="shareCouponList.length==1||shareCouponList.length==2"/>
              </div>
              <div class="couponitem" :style="{width: commonCouponWidth+'px', height:commonCouponHeight+'px'}" v-if="shareCouponList.length<2">
              <img src="/static/XRGcouponCenter.png" width="100%" height="100%" v-if="shareCouponList.length==1"/>
            </div>
          </div>
        </div>
      </div>
      <div class="couponmenu">
        <div class="couponmenu_tab" :style="{width: (couponMenuItemWidth*CategoryNavList.length)+'px'}">
          <template v-for="(item,index) in CategoryNavList" >
            <div 
              :class="couponmenuSelect==item.Id?'tab active':'tab'" 
              :style="{width:couponMenuItemWidth+'px'}"             
              :key="index" 
              @click="searchCategoryCoupon(item.Id)"
            >
              <p>{{item.Name}}</p>
              <p class="line">
                <span>&nbsp;</span>
              </p>
            </div>
          </template>
        </div> 
      </div>
      
      <div class="coupontabone">
        <div v-if="storeCouponList.length==0" :style="{height: couponheight-541+'px'}"> 
            <div style="width:100%;text-align:center;float:left;height:40%;margin-top:5%;">
              <div style="width:20%;float:left;height:1px;"></div>
              <div style="width:60%;float:left;height:100%;padding:20px 20px 0px 20px;">
              <img src="/static/nostorecouponimg.png"  height="50" width="60" v-if="couponheight-541>92" />
              <p style="font-size:16px;text-align:center;color:#D2D3D2;">暂无优惠券,敬请期待~</p>
              </div>
              <div style="width:20%;float:left;height:1px;"></div>
            </div>
        </div>
        <template v-for="(couponShop,index) in storeCouponList">
          <div class="couponlist_bg" :key="couponShop.Id" :style="{height: shopProductCouponItemHeight+'px'}" v-if="couponShop.Goods.length > 0">
            <div class="couponlist_bg_title" :style="{height: shopProductCouponItemCouponHeight+'px'}">
              <div class="coupontype">
                <span v-if="couponShop.Type==0 && couponShop.RangeType==0">平台通用券</span>
                <span v-if="couponShop.Type==0 && couponShop.RangeType==1">平台商品券</span>
                <span v-if="couponShop.Type==0 && couponShop.RangeType==2">平台分类券</span>
                <span v-if="couponShop.Type==1 && couponShop.RangeType==0">商家通用券</span>
                <span v-if="couponShop.Type==1 && couponShop.RangeType==1">商家商品券</span>
                <span v-if="couponShop.Type==1 && couponShop.RangeType==2">商家分类券</span>
              </div>
              <div class="couponlist_bg_title_price" :style="{height: (shopProductCouponItemCouponHeight-30)+'px', lineHeight: (shopProductCouponItemCouponHeight-30)+'px'}">
                <label style="font-size:15px;">￥</label>
                <label :style="{fontSize:moneySize+ 'px'}">{{couponShop.Money}}</label>
              </div>
              <div class="couponlist_bg_title_title">
                <div class="couponlist_bg_title_title_shopname" :style="{height: ((shopProductCouponItemCouponHeight-30)/2)+'px', lineHeight: ((shopProductCouponItemCouponHeight-30)/2)+'px'}">
                  <label :style="{fontSize:moneySize2+ 'px'}">{{couponShop.CompanyName}}</label>
                </div>
                <div class="couponlist_bg_title_title_remark" :style="{height: ((shopProductCouponItemCouponHeight-30)/2)+'px', lineHeight: ((shopProductCouponItemCouponHeight-30)/2)+'px'}">
                  <label :style="{fontSize:moneySize2+ 'px'}">满{{couponShop.FullMoney}}可以使用</label>
                </div>
              </div>
              <div class="couponlist_bg_title_button" :style="{marginTop:marginTopSize + 'px'}">
                <div style="width:10%;height:20%;"></div>
                <button class="couponlist_bg_title_button_btn" v-if="percent(couponShop.ReceiveAmount/couponShop.TotalAmount) !=100 && couponShop.ReceiveStatus==0" @click="btnClick2(couponShop.Id, index)">立即领取</button>
                <button class="couponlist_bg_title_button_btn" v-if="couponShop.ReceiveStatus==1" @click="goToCouponUsing(couponShop.Id)">去使用</button>
                <button class="couponlist_bg_title_button_btn" v-if="percent(couponShop.ReceiveAmount/couponShop.TotalAmount)==100 && couponShop.ReceiveStatus==0">已抢光</button>
              </div>
            </div>
            <div class="couponlist_bg_content" :style="{height: shopProductCouponItemProductHeight+'px'}">
              <template v-for="goodItem in couponShop.Goods">
                <router-link :to="'/retail/productDetail?skuId='+goodItem.SkuId" :key="goodItem.SkuId">
                <div class="couponlist_bg_content_shopinfo">
                  <dd class="couponlist_bg_content_shopinfo_img">
                    <img :src="goodItem.ImagePath" v-if="goodItem.ImagePath" />
					<img src="/static/index/index-item-default.png" v-if="!goodItem.ImagePath" />
                  </dd>
                  <dt class="couponlist_bg_content_shopinfo_txt">
                    <span style="font-size:12px;">￥</span>
                    <span style="font-size:18px;">{{goodItem.SalePrice}}</span>
                  </dt>
                </div>
                </router-link>   
              </template>
            </div>
          </div>
        </template>
      </div>
	  </v-scroll>
      <!-- <mu-divider /> -->
      <mu-paper class="bottom-nav">
        <mu-bottom-nav :value="bottomNav" @change="handleChange">
          <mu-bottom-nav-item to="/retail/coupon/CouponCenter" value="1" title="领券中心" style="background:#ff9500;color:white;" icon=":fa fa-tixian" key="1"/>
          <mu-bottom-nav-item to="/retail/coupon/CouponUse" value="2" title="我的券" icon=":fa fa-myhuiyuan" style="background:#ff0036;color:white;" key="2"/>
        </mu-bottom-nav>
      </mu-paper>
	  
      <XR-toast ref="XRtoast"></XR-toast>
	  <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      couponInfo:{
        CategoryId:'',
        pageIndex : 0,
        loaded:true,
      },
	  moneySize : 32,
	  moneySize2 : 14,
	  marginTopSize : 0,
      bottomNav:1,
      pageEnd : 0, // 结束页数
      num:15,
      ins:0,
      coupontaboneshoplist:[1,2,3],
      coupontabtwoshoplist:[4,5,6],
      coupontabthreeshoplist:[7,8,9],
      coupontabfourshoplist:[10,11,12],
      couponListNew:[100,200,300,400,500],
      couponmenulist:[
        {id: 1,name:'为你推荐'}
        ,{id:2, name:'美容护肤'}
        ,{id:3, name:'家用电器'}
        ,{id:4, name:'母婴用品'}
        ,{id:5, name:'美容护肤'}
        ,{id:6, name:'家用电器'}
        ,{id:7, name:'母婴用品'}
      ],
      couponmenuSelect:0,
      ulWidth: document.documentElement.clientWidth-99,
      CategoryNavList:[],
      shareCouponList:[],
      storeCouponList:[],
      couponWidth: document.documentElement.clientWidth-20-60-16,
      couponheight:document.documentElement.clientHeight,
      commonCouponWidth: 0,
      couponcenterWidth:0,
      GetLeft:0,
      commonCouponContainerWidth:0,
      commonCouponHeight : 0,
      couponItemContentHeight:0,
      couponItemBtnHeight:0,
      shopProductCouponItemHeight: 0,
      shopProductCouponItemCouponHeight: 0,
      shopProductCouponItemProductHeight: 0,
      couponMenuItemWidth: document.documentElement.clientWidth/3.5, 

      scrollDone:function(){},
    }
  },
  mounted:function(){
    this.commonCouponWidth = 267/750 * document.documentElement.clientWidth
    this.commonCouponContainerWidth = (this.commonCouponWidth+6)* this.couponListNew.length +6
    this.shopProductCouponItemHeight = 420/750 * document.documentElement.clientWidth
    this.GetShoppingCategoryNavList()
    this.ShareCouponList(this.$route.query.OrderNo) 
    this.WapStoreCouponList(true)
	if (document.documentElement.clientWidth <= 320){
	  this.moneySize = 28
	  this.moneySize2 = 12
	  this.marginTopSize = -6
	}
  },
  methods: {
    handleChange(val) {
      this.bottomNav = val;
    },
    GetShoppingCategoryNavList(){
      var ths = this
      ths.$post('/Shop/RetailServer/GetShoppingCategoryNavList'
        ).then(function (res) {
          if(res.IsSuccess){
            ths.CategoryNavList = res.Data
            ths.CategoryNavList.unshift({Childrens:[],FatherId:0,IconPath:'',Id:0,Name:'全部',Sort:0,TypeId:2,TypeValue:"全部"})
			console.log(ths.CategoryNavList)
          }else{
            ths.$refs.XRtoast.failed(res.Msg)
          }
        })
    },
    WapStoreCouponList(isNewSearch){
      //this.$refs.XRtoast.load()
      if(isNewSearch){        
        this.couponInfo.pageIndex=1
      }
      else{
        this.couponInfo.pageIndex++
      }
	  this.couponInfo.CategoryId=this.couponmenuSelect
	  
	  var ths=this
      ths.$post('/Shop/CouponServer/WapGrabPublicCoupon',JSON.stringify(this.couponInfo)
      ).then(function (res){
        ths.scrollDone()
        ths.$refs.XRtoast.hide()
        if(res.IsSuccess){
          if(isNewSearch){
            ths.storeCouponList = res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.storeCouponList.push(res.Data.List[i])
            }
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num 
          if(ths.storeCouponList.length <= 0){            
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRPageTip.initTip()
          }		
          $(".load-more").show();		  
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }else{
		  if(isNewSearch){
		    ths.storeCouponList = []
		    ths.$refs.XRtoast.hide(res.Msg, true)
			$(".load-more").hide();
		  }else{
		    ths.$refs.XRtoast.failed(res.Msg, true)
			$(".load-more").show();
		  }
        }
      });
    },
    ShareCouponList(order){
      var ths=this
      this.$post('/Shop/CouponServer/WapGrabCoupon',{OrderNo:order}
      ).then(function(res){
        if(res.IsSuccess){
        ths.shareCouponList=res.Data
		ths.couponcenterWidth=(ths.commonCouponWidth+7) * ths.shareCouponList.length;
          if(ths.couponcenterWidth<document.documentElement.clientWidth){
            ths.couponcenterWidth=(ths.commonCouponWidth+7) *3
          }
          if(ths.shareCouponList.length>2){
            ths.GetLeft= 6
          }
          if (ths.shareCouponList.length==2){
            ths.GetLeft= (document.documentElement.clientWidth-ths.commonCouponWidth*2) / 3
          }
          if (ths.shareCouponList.length==1){
            ths.GetLeft= (document.documentElement.clientWidth-ths.commonCouponWidth) / 2-7
          }
        }else{
          ths.shareCouponList=[]		  
        }
      })
    },	
	goToCouponUsing(id){
      this.$router.push('/retail/coupon/couponUsingRemark?id='+id)
    },

    onRefresh(done) {
      //this.getOrderList();
      done() // call done
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.couponInfo.pageIndex+1 > this.pageEnd){

        //this.$refs.XRtoast.failed("已经到最后一页", true)\
        this.$refs.scroll.infiniteDone()
        return
      }
      this.WapStoreCouponList(false);
    },
    percent(obj){
      return (obj * 100).toFixed(2);
    },
	/**
    itemClick(CategoryId,index){
       this.ins = index
       this.couponInfo.CategoryId = CategoryId
       this.WapStoreCouponList(true)
    },
	**/
    btnClick(num,index){
      if (!this.$store.state.user.SessionId) {
        this.loginUrl = "/Login";
		this.$router.push(this.loginUrl+"?redirect="+encodeURIComponent(this.$router.history.current.fullPath)+"&msg="+encodeURIComponent("请先登录再领券"));
        return;
      }else{
        var ths = this;
        ths.$post('/Shop/CouponServer/WapReceiveCoupon',{'CouponId':num}
        ).then(function (res) {
          if(res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
            ths.shareCouponList[index].ReceiveStatus=1
          } else {
			ths.$refs.XRtoast.failed(res.Msg, true)
		  }
        })
      }
    },	
	
	btnClick2(num,index){
      if (!this.$store.state.user.SessionId) {
        this.loginUrl = "/Login";
		this.$router.push(this.loginUrl+"?redirect="+encodeURIComponent(this.$router.history.current.fullPath)+"&msg="+encodeURIComponent("请先登录再领券"));
        return;
      }else{
        var ths = this;
        ths.$post('/Shop/CouponServer/WapReceiveCoupon',{'CouponId':num}
        ).then(function (res) {
          if(res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
            ths.storeCouponList[index].ReceiveStatus=1
          } else {
			ths.$refs.XRtoast.failed(res.Msg, true)
		  }
        })
      }
    },
    searchCategoryCoupon(id){
      this.couponmenuSelect = id
      this.WapStoreCouponList(true)
    }
  },
  watch: {    
    commonCouponWidth(){
      this.commonCouponHeight= 350 / 247 *  this.commonCouponWidth
      this.couponItemContentHeight = 250/350 * this.commonCouponHeight
      this.couponItemBtnHeight = this.commonCouponHeight - this.couponItemContentHeight
    },
    shopProductCouponItemHeight(){
      this.shopProductCouponItemCouponHeight = 130/420 * this.shopProductCouponItemHeight
      this.shopProductCouponItemProductHeight = this.shopProductCouponItemHeight - this.shopProductCouponItemCouponHeight
    }
  }
}
</script>
<style>
.shareGetCouponPage .mu-buttom-item{
      max-width: 100%;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_title .coupontype{
  position: relative;
  left: 2px;
  width: 75px;
  height: 20px;
  background-image: url('/static/couponcenterbg.png');
  background-repeat: no-repeat;
  background-size: 75px 20px;
  font-size: 12px;
  color: white;
  -webkit-transform-origin-x: 0;
  -webkit-transform: scale(0.70);
}
.shareGetCouponPage .mu-bottom-nav {
  position: fixed;
  bottom: -1px;
  left: 0;
  background-color: #F0F2EF;
}
  .shareGetCouponPage{
    margin: 0;
    padding-bottom: 56px;
  }
  /* 显示的优惠价格样式开始 */
  .shareGetCouponPage .couponitemPrice{
    height: 40px;
    color:#E62129;
    line-height: 40px;
    font-size: 24px;
    font-weight: 400;
    text-align:center;
  }
  /* 显示的优惠价格样式结束 */
  /* 优惠券的适用范围样式开始 */
  .shareGetCouponPage .couponitemRemark{
    text-align: center;
    height: 65px;
    margin:0 8px;
    border: 2px solid #DEDFDF;
    border-radius: 3px;
  }
  .shareGetCouponPage .couponitemRemark .txtprice{
    font-size: 14px;
    margin-top: 10px;
    color: #E7262E;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .shareGetCouponPage .couponitemRemark .txttype{
    font-size: 12px;
    color:#797777;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1.2;
    -webkit-transform: scale(0.70);
  }
  .shareGetCouponPage .couponitemRemark .txtremark{
    ffont-size: 12px;
    color:#747272;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1.2;
    -webkit-transform: scale(0.70);
  }
  /* 优惠券的使用范围样式结束 */
  /* 优惠券的使用时间样式开始 */
  .shareGetCouponPage .couponimg_conpon_bg_time{
    color: #BDBDBE;
  }
  .shareGetCouponPage .txttime{
	width:140%;
    -webkit-transform: scale(0.60);
    margin-left: -19%;
    text-align: center;
    font-size: 14px;
  }
  /* 优惠券的使用时间样式结束 */
  .shareGetCouponPage .couponItemBtn{
    text-align: center;
    color: #E72830;font-weight: 600;
    border:1px;
    border-top-color: #EAEAEB;
    border-top-style: dashed;
    border-top-width: 1px;
    width: 93%;
    margin-left: 4%;
  }

  .shareGetCouponPage .couponlist{
    width:100%;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-bottom: 20px;
  }
  .shareGetCouponPage .couponcontainer{
    overflow: hidden;
  }
  .shareGetCouponPage .couponitem{
    margin-left: 6px;
    background-image:url("/static/XRGcoupon2.png");
    background-size:cover;
    float: left;
  }
  .shareGetCouponPage .coupon_banner_bg{
    background-color: #E62129;
    overflow:hidden;
    width: 100%;
  }
  .shareGetCouponPage .coupon_banner_bg img{
    /* width: 100%; */
    display: block;
  }
  /* 商品券的详情样式开始 */
  .shareGetCouponPage .coupontabone{
    text-align: center;
    width: 100%;
    background-color: #F0F2EF;
    margin-bottom: 65px;
  }
.shareGetCouponPage .coupontabone .couponlist_bg{
  background-image: url('/static/XRGcoupon3.png');
  background-repeat: no-repeat;
  background-size: 100%;
  margin: 10px 10px;
  overflow: hidden;
}
  /* 商品券的详情样式结束 */

/* 商品券展示的标题部分样式开始 */
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_title{
  width: 100%;
  overflow: hidden;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_title .couponlist_bg_title_price{
  width: 25%;
  color:#F8352F;
  float: left;
  letter-spacing: -3px;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title{
  width: 45%;
  color: #DC465B;
  /* border: 1px solid ; */
  float: left;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title .couponlist_bg_title_title_shopname{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #DC465B;
  text-align: left;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title .couponlist_bg_title_title_remark{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #DC465B;
  text-align: left;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_title .couponlist_bg_title_button{
  width: 30%;
  /* line-height: 75px; */
  /* border: 1px solid ; */
  float: left;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_title .couponlist_bg_title_button .couponlist_bg_title_button_btn{
  border-radius: 40px;
  font-size: 14px;
  width: 80%;
  height: 30px;
  border:none;   
   outline: none;
  background: -webkit-linear-gradient(left, #F63F17 , #FE9139);
  background: -o-linear-gradient(right,#F63F17, #FE9139);
  background: -moz-linear-gradient(right, #F63F17, #FE9139);
  background: linear-gradient(to right, #F63F17 , #FE9139); 
  color:white;
}
/* 商品券展示的标题部分样式结束 */
/* 商品券推荐对应商品样式开始 */
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_content{
  width:100%;
  padding-top: 5px;
  /* border:1px solid; */
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo{
  float: left;
  width: 33.33%;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_img{
  position: relative;
  width: 70%;
  height: 83px;
  text-align:center;
  margin:0px auto 0px auto;
  overflow: hidden;
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_img img{
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%) scale(1);
  border:none;
  width: 100%;
  /* display:inline-block; */
  display:table-cell;
  /* border: 1px solid; */
}
.shareGetCouponPage .coupontabone .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_txt{
  width: 100%;
  height: 20%;
  text-align: center;
  /* border: 1px solid; */
}
/* 商品券推荐对应商品样式结束 */
/* 商品券的详情样式开始 */
  .shareGetCouponPage .coupontabtwo{
    text-align: center;
    width: 100%;
    background-color: #F1F1F1;
  }
.shareGetCouponPage .coupontabtwo .couponlist_bg{
  width: 90%;
  background-image: url('/static/XRGcoupon3.png');
  background-repeat: no-repeat;
  height: 250px;
  background-size: 100% 250px;
  margin: 10px 15px;
}
  /* 商品券的详情样式结束 */
/* 商品券展示的标题部分样式开始 */
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_title{
  width: 100%;
  height: 75px;
  /* border: 1px solid ; */
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_title .couponlist_bg_title_price{
  width: 20%;
  height: 75px;
  line-height: 75px;
  color:#F8352F;
  /* border: 1px solid ; */
  float: left;
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title{
  width: 50%;
  height: 75px;
  color: #DC465B;
  /* border: 1px solid ; */
  float: left;
  padding: 10px 2px;
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title .couponlist_bg_title_title_shopname{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 20px;
  color: #DC465B;
  text-align: left;
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title .couponlist_bg_title_title_remark{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 20px;
  color: #DC465B;
  text-align: left;
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_title .couponlist_bg_title_button{
  width: 30%;
  height: 75px;
  /* line-height: 75px; */
  /* border: 1px solid ; */
  float: left;
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_title .couponlist_bg_title_button .couponlist_bg_title_button_btn{
  border-radius: 40px;
  font-size: 15px;
  height: 40%;
  width: 80%;
  border:none;
  background: -webkit-linear-gradient(left, #F63F17 , #FE9139);
  background: -o-linear-gradient(right,#F63F17, #FE9139);
  background: -moz-linear-gradient(right, #F63F17, #FE9139);
  background: linear-gradient(to right, #F63F17 , #FE9139); 
  color:white;
}
/* 商品券展示的标题部分样式结束 */
/* 商品券推荐对应商品样式开始 */
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_content{
  width:100%;
  height: 170px;
  /* border:1px solid; */
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo{
  float: left;
  height:170px ;
  width: 30%;
  margin: 5px;
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_img{
  width: 100%;
  height: 80%;
  /* border: 1px solid; */
}
.shareGetCouponPage .coupontabtwo .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_txt{
  width: 100%;
  height: 20%;
  text-align: center;
  /* border: 1px solid; */
}
/* 商品券推荐对应商品样式结束 */
/* 商品券的详情样式开始 */
  .shareGetCouponPage .coupontabthree{
    text-align: center;
    width: 100%;
    background-color: #F1F1F1;
  }
.shareGetCouponPage .coupontabthree .couponlist_bg{
  width: 90%;
  background-image: url('/static/XRGcoupon3.png');
  background-repeat: no-repeat;
  height: 250px;
  background-size: 100% 250px;
  margin: 10px 15px;
}
  /* 商品券的详情样式结束 */
/* 商品券展示的标题部分样式开始 */
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_title{
  width: 100%;
  height: 75px;
  /* border: 1px solid ; */
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_title .couponlist_bg_title_price{
  width: 20%;
  height: 75px;
  line-height: 75px;
  color:#F8352F;
  /* border: 1px solid ; */
  float: left;
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title{
  width: 50%;
  height: 75px;
  color: #DC465B;
  /* border: 1px solid ; */
  float: left;
  padding: 10px 2px;
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title .couponlist_bg_title_title_shopname{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 20px;
  color: #DC465B;
  text-align: left;
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title .couponlist_bg_title_title_remark{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 20px;
  color: #DC465B;
  text-align: left;
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_title .couponlist_bg_title_button{
  width: 30%;
  height: 75px;
  /* line-height: 75px; */
  /* border: 1px solid ; */
  float: left;
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_title .couponlist_bg_title_button .couponlist_bg_title_button_btn{
  border-radius: 40px;
  font-size: 15px;
  height: 40%;
  width: 80%;
  border:none;
  background: -webkit-linear-gradient(left, #F63F17 , #FE9139);
  background: -o-linear-gradient(right,#F63F17, #FE9139);
  background: -moz-linear-gradient(right, #F63F17, #FE9139);
  background: linear-gradient(to right, #F63F17 , #FE9139); 
  color:white;
}
/* 商品券展示的标题部分样式结束 */
/* 商品券推荐对应商品样式开始 */
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_content{
  width:100%;
  height: 170px;
  /* border:1px solid; */
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo{
  float: left;
  height:170px ;
  width: 30%;
  margin: 5px;
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_img{
  width: 100%;
  height: 80%;
  /* border: 1px solid; */
}
.shareGetCouponPage .coupontabthree .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_txt{
  width: 100%;
  height: 20%;
  text-align: center;
  /* border: 1px solid; */
}
/* 商品券推荐对应商品样式结束 */
/* 商品券的详情样式开始 */
  .shareGetCouponPage .coupontabfour{
    text-align: center;
    width: 100%;
    background-color: #F1F1F1;
  }
.shareGetCouponPage .coupontabfour .couponlist_bg{
  width: 90%;
  background-image: url('/static/XRGcoupon3.png');
  background-repeat: no-repeat;
  height: 250px;
  background-size: 100% 250px;
  margin: 10px 15px;
}
  /* 商品券的详情样式结束 */
/* 商品券展示的标题部分样式开始 */
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_title{
  width: 100%;
  height: 75px;
  /* border: 1px solid ; */
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_title .couponlist_bg_title_price{
  width: 20%;
  height: 75px;
  line-height: 75px;
  color:#F8352F;
  /* border: 1px solid ; */
  float: left;
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title{
  width: 50%;
  height: 75px;
  color: #DC465B;
  /* border: 1px solid ; */
  float: left;
  padding: 10px 2px;
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title .couponlist_bg_title_title_shopname{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 20px;
  color: #DC465B;
  text-align: left;
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_title .couponlist_bg_title_title .couponlist_bg_title_title_remark{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 20px;
  color: #DC465B;
  text-align: left;
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_title .couponlist_bg_title_button{
  width: 30%;
  height: 75px;
  /* line-height: 75px; */
  /* border: 1px solid ; */
  float: left;
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_title .couponlist_bg_title_button .couponlist_bg_title_button_btn{
  border-radius: 40px;
  font-size: 15px;
  height: 40%;
  width: 80%;
  border:none;
  background: -webkit-linear-gradient(left, #F63F17 , #FE9139);
  background: -o-linear-gradient(right,#F63F17, #FE9139);
  background: -moz-linear-gradient(right, #F63F17, #FE9139);
  background: linear-gradient(to right, #F63F17 , #FE9139); 
  color:white;
}
/* 商品券展示的标题部分样式结束 */
/* 商品券推荐对应商品样式开始 */
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_content{
  width:100%;
  height: 170px;
  /* border:1px solid; */
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo{
  float: left;
  height:170px ;
  width: 30%;
  margin: 5px;
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_img{
  width: 100%;
  height: 80%;
  /* border: 1px solid; */
}
.shareGetCouponPage .coupontabfour .couponlist_bg .couponlist_bg_content .couponlist_bg_content_shopinfo .couponlist_bg_content_shopinfo_txt{
  width: 100%;
  height: 20%;
  text-align: center;
  /* border: 1px solid; */
}
/* 商品券推荐对应商品样式结束 */
/* 中间横排导航栏样式开始 */
  .shareGetCouponPage .couponmenu{
    overflow-x:scroll;
    overflow-y: hidden;
    padding-top: 5px;
  }
  .shareGetCouponPage .couponmenu .couponmenu_tab{
    width:700px;
    height: 48px;
    background-color: #FFFFFF;
    overflow: hidden;
  }
  .shareGetCouponPage .couponmenu .couponmenu_tab .tab{
    float:left;
    color:black;
    text-align: center;
    position: relative;
  }
  .shareGetCouponPage .couponmenu .couponmenu_tab .tab p{
   line-height: 48px;
  }
  .shareGetCouponPage .couponmenu .couponmenu_tab .tab.active p{
   color: #CC4A61;
  }
  .shareGetCouponPage .couponmenu .couponmenu_tab .tab .line{
    position:absolute;
    left: -99999px;
    bottom: 10px;
  }
  .shareGetCouponPage .couponmenu .couponmenu_tab .tab.active .line{
    left: 0;
    right:0;
    bottom: 6px;
    height: 2px;
    text-align: center;
  }
  .shareGetCouponPage .couponmenu .couponmenu_tab .tab.active .line span{
    display: inline-block;
    width:20px;
    height: 2px;
    background: #CC4A61;
  }
  .shareGetCouponPage .yo-scroll .load-more{
	height:200px;
  }
  .shareGetCouponPage .xr-pageTip{
    top:104px;
    z-index: 666666;
  }
  /* 中间横排导航栏样式完毕 */
</style>


// WEBPACK FOOTER //
// src/pages/retail/coupon/shareGetCoupon.vue